import React from 'react';

export const Delivery = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.833496 4.16797V15.0013H2.50016C2.50016 16.3821 3.61933 17.5013 5.00016 17.5013C6.381 17.5013 7.50016 16.3821 7.50016 15.0013H12.5002C12.5002 16.3821 13.6193 17.5013 15.0002 17.5013C16.381 17.5013 17.5002 16.3821 17.5002 15.0013H19.1668V10.8346L17.1274 6.75586C16.8449 6.19086 16.2682 5.83464 15.6366 5.83464H13.3335V4.16797L0.833496 4.16797ZM2.50016 5.83464H11.6668V13.3346H6.85075C6.39319 12.8269 5.73759 12.5013 5.00016 12.5013C4.26273 12.5013 3.60714 12.8269 3.14958 13.3346H2.50016V5.83464ZM8.78597 7.11882L6.66683 9.23958L5.42334 7.99609L4.24495 9.17448L6.66683 11.5964L9.96598 8.29883L8.78597 7.11882ZM13.3335 7.5013H15.6366L17.5002 11.2285V13.3346H16.8508C16.3932 12.8269 15.7376 12.5013 15.0002 12.5013C14.3568 12.5013 13.7765 12.7515 13.3335 13.1507L13.3335 7.5013ZM5.00016 13.9596C5.57433 13.9596 6.04183 14.4271 6.04183 15.0013C6.04183 15.5755 5.57433 16.043 5.00016 16.043C4.426 16.043 3.9585 15.5755 3.9585 15.0013C3.9585 14.4271 4.426 13.9596 5.00016 13.9596ZM15.0002 13.9596C15.5743 13.9596 16.0418 14.4271 16.0418 15.0013C16.0418 15.5755 15.5743 16.043 15.0002 16.043C14.426 16.043 13.9585 15.5755 13.9585 15.0013C13.9585 14.4271 14.426 13.9596 15.0002 13.9596Z"
                fill="#F8964C"
            />
        </svg>
    );
};
